import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Autocomplete
} from '@mui/material';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import configAxios from '../../../../services/configAxios';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

const addEditRestrictions = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const [infosRestrictions, setInfosRestrictions] = useState(state ? { ...state.infosEdit } : {});
  const [declarationHealth, setInfosDeclarationHealth] = useState([]);

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editRestriction')
      [navigation('/app/restrictions')];
    getDeclarationHealth();
  }, []);

  function getDeclarationHealth() {
    configAxios
      .get(`/restrictions/getQuestionsDeclarationHealth`)
      .then((response) => {
        // console.log(response.data);
        setInfosDeclarationHealth(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as perguntas de declaração de saúde no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event, autocomplete) {
    if (autocomplete) {
      if (event) {
        setInfosRestrictions({
          ...infosRestrictions,
          label: event.label,
          id_declaration_health: event.id
        });
        return;
      }
      return;
    }
    setInfosRestrictions({ ...infosRestrictions, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    const router = infosRestrictions.id
      ? '/restrictions/updateRestrict'
      : '/restrictions/addRestrict';
    configAxios
      .post(router, infosRestrictions)
      .then((response) => {
        const message = infosRestrictions.id
          ? 'Restrição atualizada com sucesso!'
          : 'Restrição inserida com sucesso!';

        NotificationManager.success(message, 'Sucesso');

        setInfosRestrictions({
          ...infosRestrictions,
          id: response.data.id,
          codplano: response.data.codplano
        });

        const nav = infosRestrictions.id
          ? `/app/editRestriction/${infosRestrictions.id}`
          : `/app/editRestriction/${response.data.id}`;

        navigation(nav, {
          state: {
            infosEdit: {
              ...infosRestrictions,
              id: infosRestrictions.id ? infosRestrictions.id : response.data.id
            }
          }
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  return (
    <RenderPage title="Restrições" id="restrictions">
      <>
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Cadastro de restrições
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para inserir e editar as restrições
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            {!isMobile && (
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/restrictions"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
                <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {infosRestrictions.id && (
                    <Grid item xs={3} md={1}>
                      <TextField
                        name="id"
                        fullWidth
                        label="ID"
                        variant="outlined"
                        size="small"
                        required
                        value={infosRestrictions.id || ''}
                        disabled
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      name="descrestricao"
                      fullWidth
                      label="Descrição do restrição"
                      variant="outlined"
                      size="small"
                      required
                      value={infosRestrictions.descrestricao || ''}
                      onChange={(event) => HandleInputChange(event)}
                      inputProps={{ maxLength: 200 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Autocomplete
                      options={declarationHealth}
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleInputChange(value, { autocomplete: true })}
                      value={infosRestrictions.label || ''}
                      defaultValue=""
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Pergunta vinculada"
                          name="id_declaration_health"
                          fullWidth
                          size="small"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={1.5}>
                    <InputLabel id="label" sx={{ mt: -2.2, fontSize: '13px' }}>
                      Status *
                    </InputLabel>
                    <Select
                      name="status"
                      fullWidth
                      size="small"
                      required
                      value={infosRestrictions.status || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem value={'ATIVO'}>Ativo</MenuItem>
                      <MenuItem value={'INATIVO'}>Inativo</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              </Box>
              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  sx={{ mr: 2 }}
                  startIcon={<Iconify icon="eva:save-fill" />}>
                  {infosRestrictions.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/restrictions"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default addEditRestrictions;
